import { render, staticRenderFns } from "./MonthlyComparison.vue?vue&type=template&id=2491ae74&scoped=true"
import script from "./MonthlyComparison.vue?vue&type=script&lang=js"
export * from "./MonthlyComparison.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2491ae74",
  null
  
)

export default component.exports